import React, { useEffect, useState } from 'react';

interface KidsaPreloaderProps {
  letters?: string;
}

const KidsaPreloader: React.FC<KidsaPreloaderProps> = ({ letters = "El Cristo" }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  if (!loading) return null;

  return (
    <div id="preloader" className="preloader">
      <div className="animation-preloader text-center">

        {/* Logo + Colegio El Cristo */}
        <div className="d-flex flex-column align-items-center justify-content-center mb-5">
          <div className="logo mb-4">
            <img
              src="/assets/kidsa/assets/img/logo/logo.png"
              alt="Logo"
              className="img-fluid"
              style={{ maxHeight: '200px' }}
            />
          </div>
          <div className="text-center">
            <p
              className="text-loading mb-2"
              style={{
                fontSize: '2.2rem',
                fontWeight: '600',
                lineHeight: '1.2',
              }}
            >
              Colegio
            </p>
            <div className="txt-loading d-flex flex-wrap justify-content-center mb-6">
              {letters.split('').map((letter, index) => (
                <span
                  key={index}
                  data-text-preloader={letter}
                  className="letters-loading animated-letter"
                  style={{
                    fontSize: '3rem',
                    fontWeight: '800',
                    animationDelay: `${index * 0.1}s`,
                    whiteSpace: letter === ' ' ? 'pre' : 'normal',
                  }}
                >
                  {letter === ' ' ? '\u00A0' : letter}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Bootstrap Spinner above Cargando */}
        <div className="d-flex flex-column align-items-center">
          <div className="spinner-border text-danger mb-2" style={{ width: '100px', height: '100px' }} role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p
            className="text-center"
            style={{ fontSize: '0.75rem', fontWeight: '500' }}
          >
            <b>Cargando</b>
          </p>
        </div>
      </div>

      {/* Bottom loader animation */}
      <div className="loader">
        <div className="row">
          <div className="col-3 loader-section section-left">
            <div className="bg"></div>
          </div>
          <div className="col-3 loader-section section-left">
            <div className="bg"></div>
          </div>
          <div className="col-3 loader-section section-right">
            <div className="bg"></div>
          </div>
          <div className="col-3 loader-section section-right">
            <div className="bg"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KidsaPreloader;